const country = "zh"
const domain = ".hasselblad.com"


function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return null;
}

const storename = getCookie('storename')
let cookieStore = 'en'
if (storename) {
    let arr = storename.split("&&&")
    if (Array.isArray(arr)) {
        cookieStore = arr[1]
    }
}
const scio = window.__scio__ = new Scio({
    cookieName: '_hass_tracking_consent',
    // delay to show the banner
    delay: 1000,
    privacyPolicy: "/policies/privacy-policy",
    // defalut 'en', support: 'en' | 'de' | 'fr' | 'es' | 'it'
    language: cookieStore.toLowerCase(),
    // defalut '', 默认按欧盟标准处理;
    country: '',
    // theme: "classic",
    // Add other country, cancat src/options/country.js
    extraCountry: ['US'],
    extraUA: ['dji-app-test'],
    // defalut '', PAMS application name
    appId: '',
    // defalut '', DEV|TEST|STAG|PROD,
    environment: '',
    // defalut false, enabled logger
    loggerEnabled: false,
    // logger server
    loggerParams: {},
    // 自动弹出，
    showAuto: true,
    // 美国自动同意所有 Cookie（欧盟默认不同意非必须 Cookie）, 美国也改为false
    acceptCookie: false,
    // 指定需要禁用的第三方服务（禁止通过 script 加载）
    services: {
        // 功能类
        preference: [],
        // 统计类
        statistics: [
            'www.google-analytics.com/analytics.js',
        ],
        // 市场营销类
        marketing: [
          'www.googleadservices.com'
        ],
        // 可直接删除
        delete: ['www.googletagmanager.com']
    },
    // 指定需要删除的 cookie, 默认删除顶级域
    cookies: {
        "preference": [],
        "statistics": [
            {
                name: "_shopify_ga",
                domain
            },
            {
                name: "_orig_referrer",
                domain
            },
            {
                name: "_landing_page",
                domain
            },
            {
                name: "_shopify_s",
                domain
            },
            {
                name: "_shopify_sa_t",
                domain
            },
            {
                name: "_shopify_tm",
                domain
            },
            {
                name: "fp",
                domain
            },
            {
                name: "_shopify_sa_p",
                domain
            },
            {
                "name": "_ga",
                domain
            },
            {
              name: /^_ga_[\w]*$/,
              domain
            },
            {
              name: /^_gat_UA[\d-]*$/,
              domain
            },
            {
              name: /^_gat_UA[\d]*$/,
              domain
            },
            {
                "name": "_gat",
                domain
            },
            {
                "name": "_gcl_au",
                domain
            },
            {
                "name": "_gid",
                domain
            },
            {
                "name": "ga_uid",
                domain
            },
            {
                name: "_orig_referrer",
                domain,
            },
            {
                name: "_shopify_tw",
                domain,
            },
            {
                "name": "www_from",
                domain
            },
            {
                name: "_shopify_s"
            },
            {
                name: "_shopify_sa_t"
            },
            {
                name: "_shopify_sa_p"
            },
            {
                name: "_shopify_y"
            }
        ],
        "marketing": [
            {
                name: "dfp",
                domain
            },
            {
                name: "_bl_uid",
                domain,
            },
            {
                name: "_cmp_a",
                domain,
            },
            {
                name: "_s",
                domain,
            },
            {
                "name": "_fbp",
                domain
            },
            {
                "name": "_rdt_uuid",
                domain
            },
            {
                "name": "_uetsid",
                domain
            },
            {
                "name": "_uetvid",
                domain
            },
            {
                "name": "cto_bundle",
                domain
            },
            {
                "name": "fcm_subscribed",
                domain
            },
            {
                "name": "MgidSensorHref",
                domain
            },
            {
                "name": "MgidSensorNVis",
                domain
            },
            {
                "name": "scarab.visitor",
                domain
            },
            {
                "name": "scarab.mayAdd",
                domain
            },
            {
                "name": "scarab.profile",
                domain
            },
            {
                "name": "wcs_bt",
                domain
            },
            {
                name: "_shopify_s"
            },
            {
                name: "_shopify_sa_t"
            },
            {
                name: "_shopify_sa_p"
            },
            {
                name: "_shopify_y"
            }
        ],
        "delete": [
            {
                "name": "browsersid",
                domain
            },
            {
                "name": "cookie_agreed",
                domain
            },
            {
                "name": "djiid",
                domain
            },
            {
                "name": "traceid",
                domain
            },
            {
                "name": "tracker_device",
                domain
            },
            {
                "name": "use_captcha",
                domain
            },
            {
                "name": "user_avatar_url",
                domain
            },
            {
                "name": "user_credit_value",
                domain
            },
            {
                "name": "user_data_reload",
                domain
            },
            {
                "name": "user_nick_name",
                domain
            },
            {
                "name": "uudid",
                domain
            }
        ]
    },

    locale: {
        en: {
            privacyPolicy: 'Cookie Policy',
            cookiePreferences: 'Cookie Preferences',
            acceptAll: 'Accept All',
            requiredOnly: 'Required Only',
            confirm: 'Confirm',
            required: '(Required)',
            bar: {
                title: 'We Value Your Privacy',
                desc:
                    'We use cookies to improve our site and your experience. By continuing to browse our site you accept our {{cookiePreferences}}.',
            },
            modal: {
                desc:
                    'Cookies are small files which, when placed on your device, enable us to provide certain features and functionality of HASSELBLAD websites and online services to you. We use the following types of cookies on our websites. View {{privacyPolicy}} for full details.',
            },
        },
        de: {
            privacyPolicy: 'Cookie-Richtlinien',
            cookiePreferences: 'Cookie-Einstellungen',
            acceptAll: 'Alle akzeptieren',
            requiredOnly: 'Nur notwendige',
            confirm: 'Bestätigen',
            required: '(Erforderlich)',
            bar: {
                title: 'Wir schätzen deine Privatsphäre',
                desc:
                    'Wir verwenden Cookies, um deinen Besuch auf unseren Webseiten zu verbessern und individuell auf dich abzustimmen. Du kannst deine Einstellungen jederzeit über {{cookiePreferences}} ändern. Mehr Details findest du in unseren {{privacyPolicy}}.',
            },
            modal: {
                desc:
                    'Cookies sind kleine Dateien, die bestimmte Funktionen auf HASSELBLAD-Webseiten und Onlinediensten ermöglichen, wenn sie auf deinem Gerät gespeichert werden. Wir verwenden die folgenden Arten von Cookies auf unseren Webseiten. Ausführliche Informationen findest du in unseren {{privacyPolicy}}.',
            },
        },
        it: {
            privacyPolicy: 'Policy per i cookie',
            cookiePreferences: 'Preferenze dei cookie',
            acceptAll: 'Accetta tutto',
            requiredOnly: 'Solo richiesti',
            confirm: 'Conferma',
            required: '(Richiesto)',
            bar: {
                title: 'HASSELBLAD rispetta la privacy degli utenti',
                desc:
                    'Utilizziamo i cookie per personalizzare e migliorare la navigazione del nostro sito Web. È possibile gestire le impostazioni in qualsiasi momento tramite {{cookiePreferences}} o leggere {{privacyPolicy}} per ulteriori informazioni.',
            },
            modal: {
                desc:
                    'I cookie sono file di piccole dimensioni che, quando vengono inseriti nel dispositivo, consentono di fornire agli utenti alcune caratteristiche e funzionalità dei siti Web HASSELBLAD, nonché servizi online. Sui nostri siti Web utilizziamo i seguenti tipi di cookie. Vedere {{privacyPolicy}} per i dettagli completi.',
            },
        },
        fr: {
            privacyPolicy: "Politique relative à l'utilisation des Cookies",
            cookiePreferences: 'Préférences Cookies',
            acceptAll: 'Tout accepter',
            requiredOnly: 'Nécessaires seulement',
            confirm: 'Confirmer',
            required: '(Obligatoire)',
            bar: {
                title: 'Nous respectons votre vie privée',
                desc:
                    "Nous utilisons des cookies pour personnaliser et améliorer votre expérience de navigation sur notre site internet. Vous pouvez modifier ces paramètres à tout moment dans les {{cookiePreferences}} ou lisez notre {{privacyPolicy}} pour plus d'informations.",
            },
            modal: {
                desc:
                    'Les cookies sont de petits fichiers qui, lorsque placés sur votre appareil, nous permettent de vous proposer certaines fonctionnalités des sites internet HASSELBLAD ainsi que des services en ligne. Nous utilisons les types de cookies suivants sur notre site internet. Consultez la {{privacyPolicy}} pour plus de détails.',
            },
        },
        es: {
            privacyPolicy: 'Política de cookies',
            cookiePreferences: 'Preferencias de cookies',
            acceptAll: 'Aceptar todas las cookies',
            requiredOnly: 'Aceptar solo cookies necesarias',
            confirm: 'Confirmar',
            required: '(Necesario)',
            bar: {
                title: 'Valoramos tu privacidad',
                desc:
                    'Usamos las cookies para personalizar y mejorar tu experiencia de navegación en nuestro sitio web. Puedes modificar la configuración en cualquier momento en {{cookiePreferences}}, así como leer la {{privacyPolicy}} para obtener más información.',
            },
            modal: {
                desc:
                    'Las cookies son pequeños archivos que, cuando se almacenan en tu dispositivo, nos permiten ofrecerte determinadas características y funciones de los servicios online y sitios web de HASSELBLAD. Nuestros sitios web usan los siguientes tipos de cookies. Para obtener más información, consulta la {{privacyPolicy}}.',
            },
        },
    },
    // List all the categories you want to display
    categories: {
        necessary: {
            necessary: true,
            locale: {
                en: {
                    title: 'Strictly Necessary Cookies',
                    desc:
                        'These cookies are essential for you to use our websites, such as the cookies used for carrying out the transmission of a communication, the cookies that record requests for information from the Internet and block web attacks so as to ensure web security, the cookies that are strictly necessary for us to provide information society services that you request. You must accept strictly necessary cookies to be able to use our websites.',
                },
                de: {
                    title: 'Notwendige Cookies',
                    desc:
                        'Diese Cookies sind für die Nutzung unserer Websites unerlässlich, um mit dir zu kommunizieren, um deine Anfragen zu bearbeiten und deine Sicherheit zu gewährleisten (z. B. Webangriffe zu blockieren). Die Cookies werden für alle grundlegenden Dienste auf unseren Webseiten benötigt. Du musst die notwendigen Cookies akzeptieren, um unsere Websites nutzen zu können.',
                },
                it: {
                    title: 'Cookie strettamente necessari',
                    desc:
                        'Questi cookie sono essenziali per l’utilizzo dei nostri siti Web, ad esempio i cookie utilizzati per effettuare la trasmissione di una comunicazione, i cookie che registrano richieste di informazioni da Internet e bloccano attacchi Web per garantire la protezione Web, i cookie strettamente necessari per fornire i servizi aziendali di informazione richiesti dall’utente. Per poter utilizzare i nostri siti Web è necessario accettare i cookie strettamente necessari.',
                },
                fr: {
                    title: 'Cookies strictement nécessaires',
                    desc:
                        "Ces cookies sont essentiels lorsque vous utilisez notre site internet, tels que les cookies de transmission de communication, les cookies d'enregistrement de demandes d'informations sur internet et bloquant les attaques de sites web pour assurer la sécurité internet, les cookies indispensables en termes de services de la société de l'information que vous demandez. Vous devez accepter les cookies strictement nécessaires afin d'utiliser notre site internet.",
                },
                es: {
                    title: 'Cookies estrictamente necesarias',
                    desc:
                        'Estas cookies son esenciales para que puedas usar nuestro sitio web. Como, por ejemplo, las cookies que se usan para facilitar la transmisión de una comunicación, las que registran solicitudes de información de Internet y bloquean ataques web para ofrecer seguridad web, y las que son estrictamente necesarias para proporcionar información a los servicios de la sociedad que se soliciten. Para poder usar nuestros sitios web, deberás aceptar las cookies estrictamente necesarias.',
                },
            },
        },
        preference: {
            locale: {
                en: {
                    title: 'Preference Cookies',
                    desc:
                        'These cookies are also known as "functionality cookies", these cookies allow us to remember choices you have made through your use of our websites, like what language you prefer, what region you are in, or what your username and password are so you can automatically log in. These cookies can help us reallocate work load among our servers and enable our webpages to respond faster.',
                },
                de: {
                    title: 'Bevorzugte Cookies',
                    desc:
                        'Diese Cookies werden auch "Funktionscookies" genannt. Sie halten fest, wie du unsere Webseiten benutzt hast, z. B. welche Sprache du bevorzugst, in welcher Region du dich befindest oder wie dein Benutzername und dein Passwort lauten, damit du dich automatisch anmelden kannst. Diese Cookies können uns dabei helfen, die Serverauslastung zu optimieren und dir schnellere Reaktionszeiten auf unseren Webseiten zu bieten.',
                },
                it: {
                    title: 'Cookie preferiti',
                    desc:
                        'Questi cookie sono anche noti come “cookie di funzionalità” e consentono di ricordare le scelte effettuate durante l’utilizzo dei siti Web, come la lingua preferita, la regione di residenza o i valori di nome utente e password per effettuare automaticamente l’accesso. Questi cookie consentono di riallocare il carico di lavoro tra i server e permettono alle pagine Web di rispondere più rapidamente.',
                },
                fr: {
                    title: 'Cookies préférentiels',
                    desc:
                        "Aussi connus comme « cookies fonctionnels », ces cookies nous permettent d'enregistrer vos choix lors de l'utilisation de notre site internet, tels que la langue préférée, votre région de résidence, ou votre identifiant et mot de passe afin de vous connecter automatiquement. Ces cookies nous aident à redistribuer la charge d'informations sur nos serveurs et permettre ainsi de meilleures performances de notre site internet.",
                },
                es: {
                    title: 'Cookies de preferencias',
                    desc:
                        'Estas cookies, también conocidas como "cookies de funcionalidad", nos permiten recordar las opciones que seleccionas cuando navegas por nuestro sitio web, como tu idioma preferido, la región en la que te encuentras o cuál es tu nombre de usuario y contraseña para que puedas iniciar sesión automáticamente. Estas cookies nos ayudan a redistribuir la carga de trabajo entre los diferentes servidores para que nuestras páginas web respondan más rápido.',
                },
            },
        },
        statistics: {
            locale: {
                en: {
                    title: 'Statistics Cookies',
                    desc:
                        'These cookies are also known as "performance cookies", these cookies collect information about how you use our websites, like which web pages you visited and which links you clicked on. These cookies can help us to improve your browsing experience on our websites.',
                },
                de: {
                    title: 'Statistik-Cookies',
                    desc:
                        'Diese Cookies sammeln Informationen darüber, wie du unsere Webseiten benutzt, z. B. welche Seiten du besucht hast und auf welche Links du geklickt hast. Diese Cookies können uns helfen, deinen Besuch auf unseren Webseiten besser zu gestallten.',
                },
                it: {
                    title: 'Cookie di statistica',
                    desc:
                        'These cookies are also known as "performance cookies", these cookies collect information about how you use our websites, like which webpages you visited and which links you clicked on. These cookies can help us to improve your browsing experience on our websites.',
                },
                fr: {
                    title: 'Cookies statistiques',
                    desc:
                        'Questi cookie sono anche noti come "cookie di prestazioni" e consentono di raccogliere informazioni sull’utilizzo dei siti Web, come le pagine Web visitate e i collegamenti selezionati. Questi cookie consentono di migliorare la navigazione dei nostri siti Web.',
                },
                es: {
                    title: 'Cookies de estadísticas',
                    desc:
                        'Estas cookies, también conocidas como "cookies de rendimiento", recopilan información acerca de cómo usas nuestro sitio web, qué páginas web visitas y qué enlaces abres. Estas cookies nos ayudan a mejorar tu experiencia de navegación en nuestros sitios web.',
                },
            },
        },
        marketing: {
            locale: {
                en: {
                    title: 'Marketing Cookies',
                    desc:
                        'These cookies can track your online activities to help us deliver more relevant advertisements or limit the number of time that the same advertisement is shown to you.',
                },
                de: {
                    title: 'Marketing-Cookies',
                    desc:
                        'Diese Cookies berücksichtigen deine Online-Aktivitäten und helfen uns relevante Werbung anzuzeigen oder Werbung zeitlich zu begrenzen.',
                },
                it: {
                    title: 'Cookie di marketing',
                    desc:
                        'Questi cookie consentono di tracciare le attività online per poter offrire pubblicità più pertinenti o limitare il numero di visualizzazioni della stessa pubblicità.',
                },
                fr: {
                    title: 'Cookies marketing',
                    desc:
                        'Ces cookies suivent votre activité en ligne pour nous aider à cibler les publicités contextuelles ou limiter le nombre d’apparition d’une publicité.',
                },
                es: {
                    title: 'Cookies de marketing',
                    desc:
                        'Estas cookies realizan un seguimiento de tus actividades en línea para ayudarnos a ofrecerte anuncios más relevantes o limitar el número de veces que se muestra el mismo anuncio.',
                },
            },
        },
    },
});

scio.on('popupOpened', (type) => {
    if (type === 'modal') {
        const body = document.body;
        body.style.overflow = 'hidden';
    }
});
scio.on('closeCookiePreference', () => {
    const body = document.body;
    body.style.overflow = 'auto';
});

scio.on('statusChanged', (type, data) => {
    const body = document.body;
    body.style.overflow = 'auto';
    try {
        if (type === "accept") {
            window.Shopify.customerPrivacy.setTrackingConsent(true)
            // dataLayer.push({event:"consent_update",'marketing':m,'statistics':s})
        }

        if (type === "deny" && Array.isArray(data)) {
            window.Shopify.customerPrivacy.setTrackingConsent(
                {
                    "analytics": data.includes("statistics"),
                    "marketing": data.includes("marketing"),
                    "preferences": data.includes("preference"),
                    "sale_of_data": false,
                },
                () => console.log("Consent captured")
            );
        }
    } catch (e) {
      console.warn('e', e)
    }
});


const openModal = () => scio.open('modal')

function callback() {
    const dom = document.getElementById('as-show-cookie-popup')
    if (dom) {
        dom.removeEventListener('click', openModal)
        dom.addEventListener('click', openModal)
    }
    const domMobile = document.getElementById('as-show-cookie-popup-m')
    if (domMobile) {
        domMobile.removeEventListener('click', openModal)
        domMobile.addEventListener('click', openModal)
        return true
    }
}


function init(callback) {
    var timer = null;
    var observer = new MutationObserver(() => {

        // 获取是否需要停止监听
        var isExist = callback();

        if (isExist) {
            // 仅当dom存在时并且定时器未设置，才清除定时器
            !timer && (timer = setTimeout(() => {
                observer.disconnect()
            }, 5000))
        } else {

            // 如果某一时间点dom不存在，清除定时器，避免dom没被渲染停止了定时器
            clearTimeout(timer);
            timer = null;
        }
    });

    function observerHandler() {
        var config = {
            attributes: false, childList: true, characterData: false, subtree: true,
        };
        observer.observe(document, config);
    }

    window.addEventListener('popstate', function () {
        observerHandler()
    });
    observerHandler()

}

init(callback);


window.onload = function () {
    window.Shopify.loadFeatures(
        [
            {
                name: 'consent-tracking-api',
                version: '0.1',
            },
        ],
        error => {
            if (error) {
                console.log('loadFeatures==error', error)
                // Rescue error
            }
        },
    );
}


